import * as React from 'react';
import { StoryblokComponent, storyblokEditable } from 'gatsby-source-storyblok';
import { StaticImage } from 'gatsby-plugin-image';

export default function HorizontalImageList({ blok }) {
  const items = [];
  for (let i = 1; i <= 2; i++) {
    if (blok?.[`image_${i}`]) {
      items.push({
        image: blok[`image_${i}`],
        heading: blok[`heading_${i}`],
        subheading: blok[`subheading_${i}`],
      });
    }
  }

  return (
    <div {...storyblokEditable(blok)}>
      {items.length > 0
                && (
                <div className="flex flex-wrap justify-center text-center mb-10 gap-12">
                  {items.map((item, index) => (
                    <div key={index} className="flex flex-col items-center">
                      <div>
                        <StaticImage
                          alt={item.image?.alt}
                          className="h-52 w-52 rounded-full mb-4"
                          src={item.image?.filename}
                          width={400}
                          height={400}
                        />
                      </div>
                      {item.heading}
                      {item.subheading && (
                      <>
                        <br />
                        {item.subheading}
                      </>
                      )}
                    </div>
                  ))}
                </div>
                )}
    </div>
  );
}
